import { render, staticRenderFns } from "./NewGradList.vue?vue&type=template&id=19e62a83&scoped=true&"
import script from "./NewGradList.vue?vue&type=script&lang=js&"
export * from "./NewGradList.vue?vue&type=script&lang=js&"
import style0 from "./NewGradList.vue?vue&type=style&index=0&id=19e62a83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e62a83",
  null
  
)

export default component.exports